import React from "react";
import { motion } from "framer-motion";


const DEFAULT_STEPS = [
  {
    num: "01",
    title: "נרשמים לקהילה",
    desc: "משאירים פרטים בטופס כאן למטה ומצטרפים רשמית.",
    color: "#c8f135",
  },
  {
    num: "02",
    title: "נכנסים לעניינים",
    desc: "נרשמים לקהילה הכי פאן שיש, מתחילים לבצע את המשימות הרשתיות ומקבלים גישה אקסקלוסיבית להקצאות הכרטיסים לאירועים הכי החמים בעולם (במחירי עלות!)",
    color: "#c8f135",
  },
  {
    num: "03",
    title: "מבטיחים את מקומכם במונדיאל",
    desc: "צוברים נקודות דרך המשימות, ויכולים להרוויח זוג כרטיסים למשחק הפתיחה של מונדיאל 2026! \u{1F3C6}\u{26BD}",
    color: "#c8f135",
  },
];

export default function HowItWorks({ onScrollToForm, loggedIn, config }) {
  const steps = config?.steps ?? DEFAULT_STEPS;
  return (
    <section className="py-20 px-4" style={{ background: "linear-gradient(180deg, #161616 0%, #252525 100%)" }} dir="rtl">
      <div className="max-w-2xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>פשוט וקל</p>
          <h2 className="font-black mb-2 text-white" style={{ fontSize: "clamp(1.6rem, 4vw, 2.4rem)" }}>
            איך זה עובד?
          </h2>
          <p className="text-sm font-semibold" style={{ color: "rgba(255,255,255,0.35)" }}>3 צעדים ואתם בפנים:</p>
        </motion.div>

        <div className="space-y-3">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="rounded-2xl p-5 flex items-start gap-5 relative overflow-hidden"
              style={{ background: "#111", border: `1.5px solid ${step.color}25` }}
            >


              <div
                className="flex items-center justify-center flex-shrink-0 font-black text-2xl"
                style={{ color: "#c8f135", minWidth: "48px" }}
              >
                {step.num}
              </div>
              <div>
                <p className="font-black text-base mb-1 text-white">{step.title}</p>
                <p className="text-sm leading-relaxed" style={{ color: "rgba(255,255,255,0.75)" }}>{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mt-10"
        >
          <button
            onClick={() => {
              if (loggedIn) {
                onScrollToForm?.();
              } else {
                window.location.href = "/account/sign-up";
              }
            }}
            className="inline-flex items-center gap-2 font-black text-base px-10 py-4 rounded-full transition-all duration-200 active:scale-95"
            style={{ background: "#c8f135", color: "#000", boxShadow: "0 6px 24px rgba(200,241,53,0.3)" }}
          >
            {loggedIn ? "רוצה להתחיל לצבור נקודות?" : (config?.cta_text ?? "\uD83D\uDC49 אני רוצה להצטרף ולהתחיל לצבור נקודות!")}
          </button>
        </motion.div>
      </div>
    </section>
  );
}